<template>
	<div v-if="selectedUser?.phoneNumber">
        <h2>{{ selectedUser?.displayName }} Inspect Account</h2>
        
        <div class="center-content">
            <div>
                <h3>Account Details</h3>
                <table class="transaction-list">
                    <tr>
                        <th>Promo Balance</th>
                        <td>{{ promoBalance }}</td>
                    </tr>
                    <tr>
                        <th>Regular Balance</th>
                        <td>{{ regularBalance }}</td>
                    </tr>
                    <tr>
                        <th>Received New User Bonus</th>
                        <td>{{ receievedNewUserBonus }}</td>
                    </tr>
                    <tr>
                        <th>Most Recent Buy In Time</th>
                        <td>{{ mostRecentBuyInTime }}</td>
                    </tr>
                    <tr>
                        <th>Most Recent Cash Out Time</th>
                        <td>{{ mostRecentCashOutTime }}</td>
                    </tr>
                    <tr>
                        <th>Most Recent Play Time</th>
                        <td>{{ mostRecentPlayTime }}</td>
                    </tr>
                    <tr>
                        <th>Last Update Time</th>
                        <td>{{ lastUpdateTime }}</td>
                    </tr>
                    <tr>
                        <th>Play Through Progress</th>
                        <td>{{ playThroughProgress }} out of {{ playThroughThreshold }}</td>
                    </tr>
                    <tr>
                        <th>Play Through Threshold</th>
                        <td>{{ playThroughThreshold }}</td>
                    </tr>
                     <tr>
                        <th>Play Through Percentage</th>
                        <td>{{ percentage }}%</td>
                    </tr>
                </table>
            </div>
            <div class="welcome-back-table-section">
                <h3>Welcome Back Limit</h3>
                <table class="transaction-list">
                    <tr>
                        <th>Welcome Back Limit Creation</th>
                        <td>{{  welcomeBackLimitCreation }}</td>
                    </tr>
                    <tr>
                        <th>Welcome Back Limit Expiration</th>
                        <td>{{  welcomeBackLimitExpiration }}</td>
                    </tr>
                    <tr>
                        <th>Welcome Back Limit Pending Transaction</th>
                        <td>{{  welcomeBackLimitPendingTransaction }}</td>
                    </tr>

                </table>
                <div class="recent-actions-section">
                    <h3>Recent Actions</h3>
                    <div class="recent-actions-input">
                        <label>Recent Action Days</label>
                        <input type="number" v-model="recentActionDays" />
                    </div> 
                </div>
                <table class="transaction-list">
                    <tr>
                        <th>Recent Buy In Count</th>
                        <td>{{ recentBuyInCount }}</td>
                    </tr>
                    <tr>
                        <th>Recent Buy In Total COC</th>
                        <td>{{  systemCurrencyTool.formatCurrency(recentBuyInTotalCOC, systemFull) }}</td>
                    </tr>
                    <tr>
                        <th>Recent Cash Out Count</th>
                        <td>{{ recentCashOutCount }}</td>
                    </tr>
                    <tr>
                        <th>Recent Cash Out Total COC</th>
                        <td>{{ systemCurrencyTool.formatCurrency(recentCashOutTotalCOC, systemFull) }}</td>
                    </tr>
                </table>
            </div>
        </div>
        <h3>Recent Transactions</h3>
        <div class="recent-changes center-content paging">
            <label>Recent Transaction Count</label>
            <input type="number" v-model="recentTransactionCount"/>
            <button @click="getUserAccountInfo(recentActionDays,recentTransactionCount)" class="btn">Apply Changes</button>
        </div>
        <div class="center-content">
		    <table class="transaction-list">
			    <tr class="sticky">
                    <th colspan="2">Initial Balance</th>
				    <th>From Player Cash</th>
				    <th>Initiation Date</th>
				    <th>Resolution Date</th>
				    <th>Status</th>
				    <th colspan="2">To Player Amount</th>
				    <th>Type</th>
                    <th>Buy-In Offer Name</th>
			    </tr>
                <tr>
                    <th>Regular</th>
                    <th>Promo</th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th>Regular</th>
                    <th>Promo</th>
                    <th></th>
                    <th></th>
                </tr>
			    <tr v-for="(transaction, index) in recentTransactions " :key="index" :value="transaction.id">
                    <td class="center">{{ systemCurrencyTool.formatFromAU(transaction.initialBalance.regularAU, systemFull)}}</td>
                    <td class="center">{{ systemCurrencyTool.formatFromAU(transaction.initialBalance.promoAU, systemFull)}}</td>
				    <td class="center">{{  systemCurrencyTool.formatCurrency(transaction.fromPlayerCashCOC, systemFull) }}</td>
                    <td class="center">{{ this.adjustDateForTimeZoneOffsetLongDate(new Date(transaction.initiationDate)) }}</td>
                    <td class="center">{{ this.adjustDateForTimeZoneOffsetLongDate(new Date(transaction.resolutionDate))}}</td>
				    <td class="center">{{transaction.status}}</td>
				    <td v-if="transaction.toPlayerAmount.regularAU >= 0" class="center">{{  systemCurrencyTool.formatFromAU(transaction.toPlayerAmount.regularAU, systemFull) }}</td>
                    <td v-else class="center negative-value">{{  systemCurrencyTool.formatFromAU(transaction.toPlayerAmount.regularAU, systemFull) }}</td>
                    <td class="center">{{  systemCurrencyTool.formatFromAU(transaction.toPlayerAmount.promoAU, systemFull) }}</td>
				    <td class="center">{{ transaction.type }}</td>
                    <td class="center">{{ transaction.OfferName }}</td>
			    </tr>
		    </table>
        </div>
	</div>
	<div v-else>
		<h2>No User Selected</h2>
	</div>
</template>

<script>

export default {
	name: "InspectUserAccount",
	props: {
		adminState: Object,
		selectedUser: Object,
		isMobile: Boolean,
		systemSettings: Object,
        systemCurrencyTool: Object,
	},
	data() {
		return {
			status: Object.assign({}, this.globalStatus),
			serverBusy: false,
            recentTransactions: [],
            receievedNewUserBonus: null,
            mostRecentBuyInTime: null,
            mostRecentCashOutTime: null,
            mostRecentPlayTime: null,
            lastUpdateTime: null,
            promoBalance: 0,
            regularBalance: 0,
            playThroughProgress: 0,
            playThroughThreshold: 0,
            recentActionDays: 30,
            recentTransactionCount: 30,
            welcomeBackLimitCreation: null,
            welcomeBackLimitExpiration: null,
            welcomeBackLimitPendingTransaction: null,
            recentBuyInCount: 0,
            recentBuyInTotalCOC: 0,
            recentCashOutCount: 0,
            recentCashOutTotalCOC: 0,
            percentage: 0,
            listOfBuyInOffers: null
		};
	},
	watch: {
		selectedUser: {
			handler() {
				if (this.selectedUser?.lastLoginDate && new Date(this.selectedUser.lastLoginDate).getTime() > 0) {
					this.lastLogin = new Date(this.selectedUser.lastLoginDate).toLocaleTimeString([], this.dateOptions);
				} else {
					this.lastLogin = "No login records found.";
				}
                this.getUserAccountInfo(this.recentActionDays,this.recentTransactionCount);
			},
			deep: true,
		},
	},
    created() {
        this.getUserAccountInfo(this.recentActionDays,this.recentTransactionCount);
    },
	methods: {

        async getUserAccountInfo(recentActionDays, recentTransactionCount) {

            let body = {
                UserId: this.selectedUser.userId,
				CasinoId: this.adminState.casinoId,
				RecentTotalsDays: recentActionDays,
				RecentTranCount: recentTransactionCount,
			};

            let requestUrl = new URL("/api/v1/funds/inspect", this.rabbitsfootHostUrl);
            let headerObj = new Headers();
			headerObj.append("Authorization", `Bearer ${this.adminState.accessToken}`);
			headerObj.append("Content-Type", "application/json; charset=utf-8");
			
			let request = new Request(requestUrl.toString(), {
				method: "POST",
                body: JSON.stringify(body),
				headers: headerObj,
			});

			try {
				const response = await fetch(request);
				let dataJson = await response.json();
                this.receievedNewUserBonus = dataJson.hasReceivedNewUserBonus;
                this.mostRecentBuyInTime = dataJson.account?.mostRecentBuyInTime ? this.adjustDateForTimeZoneOffsetLongDate(new Date(dataJson.account.mostRecentBuyInTime)) : "None";
                this.mostRecentCashOutTime = dataJson.account?.mostRecentCashOutTime ? this.adjustDateForTimeZoneOffsetLongDate(new Date(dataJson.account.mostRecentCashOutTime)) : "None";
                this.mostRecentPlayTime = dataJson.account?.mostRecentPlayTime ? this.adjustDateForTimeZoneOffsetLongDate(new Date(dataJson.account.mostRecentPlayTime)) : "None";
                this.lastUpdateTime = dataJson.account?.lastUpdateTime ? this.adjustDateForTimeZoneOffsetLongDate(new Date(dataJson.account.lastUpdateTime)) : "None";
                this.promoBalance =  this.systemCurrencyTool.formatFromAU(dataJson.account?.balance.promoAU, this.systemFull);
                this.regularBalance =  this.systemCurrencyTool.formatFromAU(dataJson.account?.balance.regularAU, this.systemFull);
                this.playThroughProgress =  this.systemCurrencyTool.formatFromAU(dataJson.account?.playthroughProgressAU, this.systemFull);
                this.playThroughThreshold = this.systemCurrencyTool.formatFromAU(dataJson.account?.playthroughThresholdAU, this.systemFull);
                this.welcomeBackLimitCreation = dataJson.welcomeBackLimitCreation ?  this.adjustDateForTimeZoneOffsetLongDate(new Date(dataJson.welcomeBackLimitCreation)): "None";
                this.welcomeBackLimitExpiration = dataJson.welcomeBackLimitExpiration ?  this.adjustDateForTimeZoneOffsetLongDate(new Date(dataJson.welcomeBackLimitExpiration))  : "None";
                this.welcomeBackLimitPendingTransaction = dataJson.welcomeBackLimitPendingTran ? dataJson.welcomeBackLimitPendingTran : "None";
                this.recentBuyInCount = dataJson.recentBuyInCount;
                this.recentBuyInTotalCOC = dataJson.recentBuyInTotalCOC;
                this.recentCashOutCount = dataJson.recentCashOutCount;
                this.recentCashOutTotalCOC = dataJson.recentCashOutTotalCOC;
                this.recentTransactions = dataJson.recentTransactions;
                this.getPercentage(dataJson.account?.playthroughProgressAU, dataJson.account?.playthroughThresholdAU);

                await this.getBuyInOffer();

                for(let i =0; i < this.recentTransactions.length; i++) {
                    for(let j = 0; j < this.listOfBuyInOffers.length; j++) {
                        if(this.recentTransactions[i].buyInOfferId == this.listOfBuyInOffers[j].id) {
                            this.recentTransactions[i].OfferName = this.listOfBuyInOffers[j].publicName;
                        }
                    }
                }

				return dataJson;
			} catch (e) {
				console.error(e);
			}
        },

        getPercentage(playthroughProgress, playthroughThreshold) {
            let percentage = ( playthroughProgress / playthroughThreshold) * 100;
            if(playthroughProgress == 0 && playthroughThreshold == 0 || playthroughProgress == undefined || playthroughThreshold == undefined) {
                this.percentage = 0;
            }else{
                 this.percentage = percentage.toFixed(2);
            }           
        },

        async getBuyInOffer() {

            let requestUrl = new URL(`/api/v1/offer`, this.rabbitsfootHostUrl);
			let headerObj = new Headers();
			headerObj.append("Authorization", `Bearer ${this.adminState.accessToken}`);
			headerObj.append("Content-Type", "application/json; charset=utf-8");

            let params = requestUrl.searchParams;

            params.set("limit", 50);
            requestUrl.search = params.toString();

			let request = new Request(requestUrl.toString(), {
				method: "GET",
				headers: headerObj,
			});

			try {
				let response = await fetch(request);

				let dataJson = await response.json();
                this.listOfBuyInOffers = dataJson;

				this.serverBusy = false;
				this.busyText = "";
			} catch (e) {
				this.status.code = e;
				this.status.ok = false;
				this.userMustDismiss = true;
				console.error(e);
				return false;
			}
        },
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.btn {
	display: block;
	margin: 15px auto 5px;
}

.center {
    text-align: center;
}

.transaction-list th,
.transaction-list td {
    border: 1px #000 solid;
    padding: 5px 10px;

}

.transaction-list tr:nth-child(2n) {
	background-color: #bfbfbf;
}
.negative-value {
	color: red;
}

.center-content {
    display: flex;
    justify-content: center;
}

input {
    width: 5vw;
}

.btn {
    margin: 5px 5px;
}

.recent-changes {
    margin-bottom: 10px;
}

.welcome-back-table-section {
    margin-left: 7%;
    display: grid;
}

.recent-actions-section {
    display: grid;
    justify-content: center;
}

.recent-actions-input {
    display: flex;
    justify-content: center;
}

</style>
